<template>
  <div class="fc-day-breakdown">
    <ul>
      <calendar-day-breakdown-event
        v-for="(event, index) in events"
        :key="index"
        :event="event"/>
    </ul>
  </div>
</template>

<script>
import CalendarDayBreakdownEvent from './CalendarDayBreakdownEvent'

export default {
  props: {
    events: {
      required: true,
      type: Array
    }
  },

  components: {
    CalendarDayBreakdownEvent
  }
}
</script>
